import { desc, jobOfferId } from "./validations";

export const ProposalValidate = {
  desc,
  jobOfferId,
};
